import { Link } from "react-router-dom";

export default function FaqSection() {
  const faqs = [
    {
      q: "O que é HoobuySpreadsheet?",
      a: "O hoobuyspreadsheet é um sistema de organização de produtos que reúne milhares de itens verificados em planilhas atualizadas diariamente, facilitando compras internacionais com segurança e economia."
    },
    {
      q: "É seguro usar as planilhas do Hoobuy?",
      a: "Sim, todas as planilhas são verificadas regularmente por uma comunidade ativa. Os links são testados, produtos falsificados são removidos e apenas fornecedores confiáveis permanecem nas listas."
    },
    {
      q: "Como encontrar os melhores produtos?",
      a: "Navegue pelas categorias, compare avaliações e preços na planilha, e escolha os itens com melhor custo-benefício. As listas são organizadas por popularidade para facilitar sua escolha."
    },
    {
      q: "As planilhas são atualizadas com que frequência?",
      a: "As planilhas do hoobuyspreadsheet 2026 são atualizadas diariamente. Nossa comunidade verifica links, preços e disponibilidade a cada 24 horas."
    },
    {
      q: "Preciso pagar para acessar as planilhas?",
      a: "Não, o hoobuyspreadsheet é completamente gratuito. Todas as planilhas e listas de produtos estão disponíveis sem custo para consulta e uso."
    },
    {
      q: "Posso confiar nos links de compra?",
      a: "Absolutamente. Todos os links são verificados antes de serem adicionados e monitorados continuamente. Links quebrados ou problemáticos são removidos automaticamente."
    }
  ];

  return (
    <section className="relative py-28 md:py-36 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-6 md:px-16">
        <div className="max-w-3xl mx-auto">
          {/* Header */}
          <div className="text-center">
            <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100/80 text-accent-700 text-xs font-semibold uppercase tracking-wider whitespace-nowrap">
              FAQ
            </span>
            <h2 className="mt-5 text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight">
              Perguntas Frequentes sobre<br />
              <span className="italic font-normal">HoobuySpreadsheet</span>
            </h2>
            <p className="mt-4 text-foreground-500 text-sm max-w-lg mx-auto">
              Tire suas dúvidas sobre como funciona o hoobuyspreadsheet e comece a economizar em suas compras internacionais.
            </p>
          </div>

          {/* FAQ Items */}
          <div className="mt-14 space-y-3">
            {faqs.map((faq, idx) => (
              <details key={idx} className="group border border-secondary-200 rounded-2xl overflow-hidden bg-white">
                <summary className="flex items-center justify-between px-6 py-5 cursor-pointer list-none select-none">
                  <span className="text-sm font-semibold text-foreground-900 pr-4">{faq.q}</span>
                  <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full bg-secondary-100 text-foreground-600 group-open:bg-accent-100 group-open:text-accent-700 transition-colors">
                    <i className="ri-add-line text-sm group-open:hidden"></i>
                    <i className="ri-subtract-line text-sm hidden group-open:block"></i>
                  </span>
                </summary>
                <div className="px-6 pb-5">
                  <p className="text-sm text-foreground-500 leading-relaxed">{faq.a}</p>
                </div>
              </details>
            ))}
          </div>

          {/* CTA inside FAQ */}
          <div className="mt-14 text-center">
            <p className="text-sm text-foreground-500 mb-5">
              Ainda tem dúvidas? Leia nosso guia completo sobre o hoobuyspreadsheet.
            </p>
            <Link
              to="/guia/artigo-hoobuy-spreadsheet"
              className="inline-flex items-center gap-2 h-12 px-7 rounded-full border-2 border-foreground-300 text-foreground-800 text-sm font-semibold whitespace-nowrap cursor-pointer hover:bg-secondary-100 transition-all"
            >
              Ler Guia Completo
              <i className="ri-arrow-right-line text-sm w-4 h-4 flex items-center justify-center"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}